/**
 * @flow
 * @relayHash 5fdf3793035d40e34b9af1849841e5e0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TVShowApp_viewer$ref = any;
export type queries_TVShowApp_QueryVariables = {|
  page: number,
  states?: ?$ReadOnlyArray<?string>,
|};
export type queries_TVShowApp_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: TVShowApp_viewer$ref
  |}
|};
export type queries_TVShowApp_Query = {|
  variables: queries_TVShowApp_QueryVariables,
  response: queries_TVShowApp_QueryResponse,
|};
*/


/*
query queries_TVShowApp_Query(
  $page: Int!
  $states: [String]
) {
  viewer {
    ...TVShowApp_viewer_in1hr
    id
  }
}

fragment TVShowApp_viewer_in1hr on Viewer {
  tvshows: tvshowsPaginate(pageSize: 100, page: $page, states: $states) {
    totalCount
    tvShows {
      id
      title
      categoryName
      order
      isProject
      state
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "states",
    "type": "[String]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_TVShowApp_Query",
  "id": null,
  "text": "query queries_TVShowApp_Query(\n  $page: Int!\n  $states: [String]\n) {\n  viewer {\n    ...TVShowApp_viewer_in1hr\n    id\n  }\n}\n\nfragment TVShowApp_viewer_in1hr on Viewer {\n  tvshows: tvshowsPaginate(pageSize: 100, page: $page, states: $states) {\n    totalCount\n    tvShows {\n      id\n      title\n      categoryName\n      order\n      isProject\n      state\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_TVShowApp_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "TVShowApp_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_TVShowApp_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "tvshows",
            "name": "tvshowsPaginate",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 100,
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states",
                "type": "[String]"
              }
            ],
            "concreteType": "TVShowsPagination",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalCount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tvShows",
                "storageKey": null,
                "args": null,
                "concreteType": "TVShow",
                "plural": true,
                "selections": [
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "categoryName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "order",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isProject",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "state",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6fdb34bd3064339f7c73e403073aabe4';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_TVShowApp_Query.graphql.js